import React, { useState } from 'react';
import { Dialog, Typography, Grid, Box, DialogContent, IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'utils/makeStylesAdapter';
import { useDropzone } from 'react-dropzone';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { toast } from 'react-toastify';
import HeaderModal from 'components/HeaderModal';
import { colors } from 'utils/colorsSteps';
import ButtonConsensus from 'components/ButtonConsensus';
import intimationService from 'services/intimation/intimationService';

const useStyles = makeStyles(() => ({
  dropzone: {
    height: '100%',
    width: '100%',
    border: '1px dashed #292929',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 10,
    cursor: 'pointer',
  },
}));

const ModalAddFile = props => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { open, onClose, selectedItem } = props;

  const [files, setFiles] = useState([]);

  const [loading, setLoading] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    //accept: 'application/pdf',
    multiple: true,
    onDrop: files => getBase64(files),
  });

  //Converter arquivo para Base64
  const getBase64 = files => {
    files.forEach(file => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result;
        setFiles(files => [
          ...files,
          {
            name: file.name,
            base64,
          },
        ]);
      };
      reader.onerror = function(error) {
        toast.warn(error);
      };
    });
  };

  const handleSendFiles = () => {
    setLoading(true);

    const arrayPromisses = [];

    files.forEach(file => {
      arrayPromisses.push(
        intimationService
          .uploadVictimIntimationAttachments(selectedItem.victimIntimation.id, {
            name: file.name,
            base64: file.base64,
          })
          .then(() => {
            toast.success(`Arquivo ${file.name} anexado com sucesso`);
            setFiles(files => files.filter(item => item.name !== file.name));
          })
          .catch(() => toast.warn(`Erro ao anexar o arquivo ${file.name}`)),
      );
    });

    Promise.all(arrayPromisses).finally(() => setLoading(false));
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={onClose}
      open={open}
      className={classes.modal}
      maxWidth="sm"
      fullWidth
    >
      <HeaderModal
        onClose={onClose}
        backgroundColor={colors.navBar}
        colorIconTitle={colors.greySecundary}
      >
        Adicionar Arquivos
      </HeaderModal>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid style={{ minHeight: 150 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Box {...getRootProps({ className: 'dropzone' })} className={classes.dropzone} mt={2}>
              <input {...getInputProps()} />
              <Typography>Arraste um arquivo, ou clique para adicionar</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Box mt={2}>
              <Typography variant="h5">Arquivos</Typography>
              {files.length > 0 ? (
                files.map((file, index) => (
                  <Box key={index} display="flex" justifyContent="space-between">
                    <Box display="flex" alignItems="center" mt={1}>
                      <DescriptionIcon style={{ marginRight: 5 }} />
                      <Typography variant="body1">{file.name}</Typography>
                    </Box>
                    <IconButton
                      onClick={() =>
                        setFiles(files => files.filter((_item, fileIndex) => fileIndex !== index))
                      }
                    >
                      <HighlightOffIcon style={{ color: '#e81224' }} />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <Typography>Não há arquivos</Typography>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center" my={2}>
          <ButtonConsensus
            title="Enviar arquivos"
            onClick={handleSendFiles}
            disabled={loading || !files.length}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalAddFile;
